import { CommonEventHandler } from "@cervval.js/common/src/tools/event.tools";
import { anyReallyAny } from "@cervval.js/common/tools";

export const OFFLINE_SERVICE = "OFFLINE_SERVICE";

/** This service can be used to know if the client is offline */
export interface OfflineService {
    /**
     * @returns false if client is connected to the server, true if last connection to server failed, not_determined_yet if no connection was done yet
     */
    isOffline(): boolean | "not_determined_yet";

    /**
     * When a service (usually websocket or route services) have a successful / errored connection to server they call setOfflineStatus
     */
    setOfflineStatus(p: { offline: boolean, origin: string }): void;

    /** 
     * Event emitted when offline status changes detail contains new status and the name of the service that changed the status
     */
    offlineStatusChange: CommonEventHandler<{ offline: boolean, origin: string }>;

    /**
     * wrap the function to have a different behavior if offline
     * @param params
     * @param params.fn the function to wrap
     * @param params.offlineFn the function to call instead of fn if not online (meaning undetermined or offline)
     * @param params.cacheResult
     * @param params.cacheResult.cacheUid if defined, keep last successful online fn call result within cache storage, returns the cached result if client is offline
     * @param params.cacheResult.expirationDelaySeconds specific expiry delay in seconds
     */
    wrap<T extends Array<anyReallyAny>, V>(params: {
        /** function to call if online */
        fn: (...args: T) => Promise<V>,
        /** function to call if offline */
        offlineFn?: (...args: T) => Promise<V>,
        /** cache online call result */
        cacheResult?: {
            cacheUid: string,
            expirationDelaySeconds?: number
        }
    }): (...args: T) => Promise<V>;
}